import { content, isContentPublishing, commentCount } from '../state'
import { postsService } from '../../../services/posts/posts-service'

/**
 * Update the comment count
 * @param {number} count - New comment count
 */
export const updateCommentCount = (count) => {
  commentCount.value = count
}

/**
 * Publish a post
 * @param {string|number} postId - ID of the post to publish
 * @param {string} assetId - Asset ID
 * @param {Function} emitFn - Function to emit updates to parent component
 * @returns {Promise<boolean>} Success status
 */
export const publishPost = async (postId, assetId, emitFn) => {
  isContentPublishing.value = true
  
  try {
    const result = await postsService.publishPost({
      rowId: postId,
      assetId: assetId,
      platforms: content.value.platforms,
    })

    if (result) {
      content.value.isPublished = true
      emitFn('update:isPublished', true)
      return true
    }
    
    return false
  } catch (error) {
    console.error('Error publishing post:', error)
    return false
  } finally {
    isContentPublishing.value = false
  }
}

/**
 * Open an external link in a new tab
 * @param {string} url - URL to open
 */
export const openExternalLink = (url) => {
  window.open(url, '_blank')
}
